exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Flash{width:100%;height:260px;position:relative}.Flash .player{height:100%;width:100%}.Flash .hider{top:0}.Flash .label{text-align:center;-ms-flex:1 1 0px;flex:1 1 0;line-height:1.2;white-space:normal;word-wrap:normal}.Flash .hidden{display:none;visibility:\"hidden\"}.Flash .placeholder{height:100%;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
